<script>
  import { numberSplit } from 'public/utils'
  export default {
    name: 'KyeFieldMoney',
    props: {
      value: [String, Number]
    },
    render (h) {
      let text = this.$slots && this.$slots.default && this.$slots.default[0] && this.$slots.default[0].text
      text = this.value || text || ''
      if (this.value === 0) {
        text = 0
      }
      if (text && typeof text === 'string') {
        text = text.trim()
      }
      text = numberSplit(text)
      return (
        <span class="kye-field-content" title={ text }>
          <label>{ text }</label>
        </span>
      )
    }
  }
</script>



// WEBPACK FOOTER //
// src/public/components/kye-field-money/index.vue